import { getStaticPage } from '../../lib/static-content';
import { Breadcrumb } from './Breadcrumb';

export function StaticPage({ slug }: { slug: string }) {
  const page = getStaticPage(slug);
  return (
    <section className="about-item-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Breadcrumb
              items={[
                { label: 'الرئيسية', href: '/' },
                { label: page.breadcrumb, active: true },
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="about-tab-btn mt-4">
              <div className="about-post-items">
                {/* h1, not h2: this is the page's own subject. Static pages had
                    no h1 at all, so Google had to infer the topic from <title>. */}
                <h1 className="title mb-4">{page.title}</h1>
                <div
                  className="page-content tiptap-content"
                  dangerouslySetInnerHTML={{ __html: page.html }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
